import React, { useState, useContext, useEffect, forwardRef, useRef } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import { Context } from '@routes/private/Editor/Context';
import ComboBox from '@components/ComboBox';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CalendarIcon } from '@assets/icons/calendarIcon';
import moment from "moment";
import { getCommonValue } from 'utils/multiEditing';
import {getTaggedVisibleElementsId} from 'utils/selectDescribe'

const MultiEditingCalendarAttribute:React.FC<IProps> = (props) => {  
  const inputRef = useRef(null);
  const context = useContext(Context);
  const [dateformat, setDateformat] = useState<string>("");
  const [value, setValue] = useState("");
 
  
  const handleFocusInput = () => {
    context.onMultiEditingFocus([props.selectDescribeFieldId]);
    const commonValue = getCommonValue(props.name,props.elementType,props.selectDescribeFieldId,context.data,context.selectDescribe?.taggedFields);
    setValue(commonValue);
  }

  useEffect(() => {
    const commonValue = getCommonValue(props.name,props.elementType,props.selectDescribeFieldId,context.data,context.selectDescribe?.taggedFields);
    setValue(commonValue);
    const ref: HTMLInputElement|null = inputRef.current
    if (ref) {
      (ref as HTMLInputElement).value = commonValue;
    }
  }, [props.fieldId, context.editorStatus.setsSelected])

  const actualDateFormat = () => {
    return dateformat!==""?dateformat:"MM/DD/YYYY";
  }

  const handleChange = (date: Date| null, e:any)=> {
    const text = moment(date).format(actualDateFormat());
    const elementsIds = getTaggedVisibleElementsId([props.selectDescribeFieldId], context.selectDescribe!.taggedFields, context.data);
    context.onCommandChange(props.name,text,elementsIds,undefined,undefined,true);
    setValue(text)    
  }

  const handleSelectDateFormat = (optionId:string, optionValue:string) => {
    if (!isNaN(Date.parse(moment(value,actualDateFormat()).toString()))) {
      const text = moment(value,actualDateFormat()).format(optionValue);
      const elementsIds = getTaggedVisibleElementsId([props.selectDescribeFieldId], context.selectDescribe!.taggedFields, context.data);
      context.onCommandChange(props.name,text,elementsIds,undefined,undefined,true);
      setValue(text);
    }
    setDateformat(optionValue);
  }

  return (
    <S.Container onFocus={handleFocusInput}>       
        <DatePicker           
          customInput={<S.TextBoxContainer><S.TextBoxInput ref={inputRef} value={value}></S.TextBoxInput><S.IconContainer><CalendarIcon/></S.IconContainer></S.TextBoxContainer>}
          selected={value && value!=="" && !isNaN(Date.parse(moment(value,actualDateFormat()).toString())) && (moment(value,actualDateFormat())) ? moment(value,actualDateFormat()).toDate() : new Date()}           
          onChange={handleChange}          
         />                      
    <ComboBox 
      id="calendar-format"
      placeholder="Format"
      options={props.formating?.datesFormats??[]}
      required={false}                
      disabled={false}
      position={"bottom"}    
      chooseOption={handleSelectDateFormat}
      value={dateformat}
      light={true}
    />
    </S.Container>
  );

  
}

export default MultiEditingCalendarAttribute;